import React from 'react';
import { motion } from 'framer-motion';
export const HookSection = () => {
  return <section className="py-20 sm:py-32 px-4 bg-white" data-id="element-85">
      <div className="max-w-3xl mx-auto text-center" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-87">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-brand-dark mb-8 leading-tight" data-id="element-88">
            Does it feel like the ground is shifting under your feet?
          </h2>

          <div className="space-y-6 text-lg sm:text-xl text-brand-dark/80 leading-relaxed text-left" data-id="element-89">
            <p data-id="element-90">
              You see the news. You hear the whispers in the office. Companies
              aren't just "exploring" AI anymore—they are restructuring around
              it.
            </p>
            <p data-id="element-91">The truth is brutal:</p>
            <p className="font-serif text-2xl sm:text-3xl font-bold text-brand-dark leading-snug border-l-4 border-brand-accent pl-6 py-2 my-8" data-id="element-92">
              AI won't replace you, but a professional who knows how to direct
              AI will.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};